module.exports = __webpack_public_path__ + "static/media/sennheiser-gsp-300.608d6ba6.jpg";